import HttpFactory from '../factory';

export interface GalleryPaint {
  imageUrl: string;
  [key: string]: unknown;
}

class GalleryModule extends HttpFactory {
  /**
   * Одобренные фото по клубу для галереи (paint-for-club backend).
   */
  async getApprovedPaintsByClub(settings: {
    count?: number;
    club?: string;
    isTelegramNickname?: boolean;
  } = {}): Promise<GalleryPaint[]> {
    const { count = 10, club = 'CSKA', isTelegramNickname = false } = settings;
    const fetcher = (this as unknown as { $fetch: (url: string, opts?: object) => Promise<unknown> }).$fetch;
    const raw = await fetcher('user-paints/many', {
      method: 'GET',
      params: { count, isTelegramNickname, club },
      retry: 0,
    }) as GalleryPaint[] | { data?: GalleryPaint[] };
    const list = Array.isArray(raw) ? raw : (raw && 'data' in raw && Array.isArray(raw.data) ? raw.data : []);
    return list;
  }
}

export default GalleryModule;
